export default __webpack_public_path__ + "static/media/mcloud.a55d9a49.png";